import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-two-sections-horizontal-layout-component`,
    templateUrl: 'twoSectionsHorizontalLayout.component.html',
    styleUrls: ['../layout.component.scss']
})

export class TwoSectionsHorizontalLayoutComponent extends LayoutComponent { }

export class TwoSectionsHorizontalLayout extends Layout {
    public type = 'TwoSectionsHorizontalLayout';
    public componentType = TwoSectionsHorizontalLayoutComponent;
    public numberOfSections = 2;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsHorizontalLayout/twoSectionsHorizontalLayout.component.ts